<!-- /* eslint-disable*/ -->

<div class="sub-menu-hover" *ngIf="details.label !== 'LEFT_NAV.SUBNAV_ENVISION.EDATA_AND_INVENTORY_ALARMS'; else alarmContent">
  <li [id]="details.label">
    <a (click)="menuItemClick($event)" class="sub-menu-link title-small font-bold submenu-margin"
      [attr.href]="submenuHref" [attr.target]="details?.target ? details?.target : null"
      [ngClass]="{'no-wrap-words': enableNoWrap}">
      <span class="sub-menu-span">
        <img class="icon-css" src="./../../../assets/images/menus/arrows/arrow-right.svg"></span>
      <span class="sub-menu-span" [innerHTML]="details.label |
      translate"></span>
    </a>
  </li>
</div>
<ng-template #alarmContent>
  <div *ngIf="(userType === 1 || userType === 2) && permissionPresent">
    <div class="sub-menu-hover">
      <li [id]="details.label">
        <a (click)="menuItemClick($event)" class="sub-menu-link title-small font-bold submenu-margin"
          [attr.href]="submenuHref" [attr.target]="details?.target ? details?.target : null">
          <span class="sub-menu-span">
            <img class="icon-css" src="./../../../assets/images/menus/arrows/arrow-right.svg"></span>
          <span class="sub-menu-span" [innerHTML]="details.label |
      translate"></span>
        </a>
      </li>
    </div>
  </div>
</ng-template>